require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./impact-of-anti-racial-profiling-training.json") })
        }
      }, "path---impact-of-anti-racial-profiling-training");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---impact-of-anti-racial-profiling-training!./.cache/json/impact-of-anti-racial-profiling-training.json
// module id = 905
// module chunks = 231608221292675